export class TextUtils {
    public static capitalize = (text: string) => text[0].toUpperCase() + text.substring(1);

    public static weightDescription = (weight: string) => {
        switch (weight) {
            case "400":
                return "Regular";
            case "500":
                return "Medium";
            default:
                return "Bold";
        }
    };

    public static variantDescription = (variant: string): string => {
        switch (variant) {
            case "body1":
                return "Body 1";
            case "body2":
                return "Body 2";
            case "button":
                return "Button";
            case "caption":
                return "Caption";
            case "h1":
                return "Heading 1";
            case "h2":
                return "Heading 2";
            case "h3":
                return "Heading 3";
            case "h4":
                return "Heading 4";
            case "h5":
                return "Heading 5";
            case "h6":
                return "Heading 6";
            case "overline":
                return "Overline";
            case "subtitle1":
                return "Subtitle 1";
            case "subtitle2":
                return "Subtitle 2";
        }

        return "Body 1";
    };

    public static getPlainText = (html: string): string => {
        const template = document.createElement("template");
        template.innerHTML = html || "";

        const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_TEXT, null);
        let content = "";
        let node;
        while ((node = walker.nextNode())) {
            content += node.textContent;
        }

        return content;
    };
}
